<template>
  <div class="youtaofang">
    <topTitle
      title="柏庭荟"
      :list="list"
      :newData="newData"
      :ContentStatus="ContentStatus"
      :remakTitle="remakTitle"
    ></topTitle>
    <p class="top_p">
      钱湖柏庭休闲俱乐部有7个社团，分别是电脑社团、读书社团、旅游社团、美食社团、摄影社团、养生社团、纸艺社团。
    </p>
    <p class="top_p title" style="margin: 0">一、电脑社团</p>
    <p class="top_p" style="margin: 0">
      在飞速发展的当今，习惯地运用电脑，购物，娱乐，查阅，学习等等，已然成为一种新的生活方式。
    </p>
    <p class="top_p" style="margin: 0">
      柏庭的电脑社团可以说是为长者们量身打造，可以更有效的交流学习，更早的习惯用电脑来改变自己的生活。
    </p>
    <!-- <div class="item_img">
      <img src="../../assets/image/club/wenyi.jpg" alt="" />
    </div> -->
    <p class="top_p title" style="margin: 0">二、读书社团</p>
    <p class="top_p" style="margin: 0">读书是什么？</p>
    <p class="top_p" style="margin: 0">
      是辨认、理解、分析的过程，也是朗读、鉴赏、记忆的行为。
      柏庭的读书社团，让每一位长者都能接受文化的熏陶，“腹有诗书气自华”~
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/xiuxian.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">三、旅游社团</p>
    <p class="top_p" style="margin: 0">
      有人说：“人生至少要有两次冲动：一场奋不顾身的爱情和一段说走就走的旅行。”
    </p>
    <p class="top_p" style="margin: 0">
      如果，你还没有踏上那条梦寐的旅途，不妨来柏庭的旅游社团，与一群好友，向着同一个目的地，起航出发，相信这样的旅途会是新鲜而愉悦的~
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/xiuxian_1.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">四、美食社团</p>
    <p class="top_p" style="margin: 0">民以食为天。</p>
    <p class="top_p" style="margin: 0">
      寻找美食，享受美食，是人生中最美好的事情了，那么，与志同道合的吃货们一起，更是难得的幸事。
    </p>
    <p class="top_p" style="margin: 0">
      柏庭的美食社团，便聚集着这么一群老饕，邀请你踏上一段美食之旅。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/xiuxian_2.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">五、摄影社团</p>
    <p class="top_p" style="margin: 0">
      留住当下，让记忆成为永恒，摄影的意义在于定格这一刻的美好，柏庭的摄影社团是诸多摄影爱好者的聚集地，在这里，你会突然发现，从此你会留意到光线、形状、色彩、质感、人物、建筑、树木、花朵……
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/xiuxian_3.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">六、养生社团</p>
    <p class="top_p" style="margin: 0">
      对自己好一点就能够活得长一点，这也是养生的意义所在。
    </p>
    <p class="top_p" style="margin: 0">
      而在柏庭养生社团，能与来自各界的朋友们，交流养生的心得，学习如何更科学的对自己好一点，健康常伴。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/xiuxian_4.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">七、纸艺社团</p>
    <p class="top_p" style="margin: 0">
      纸艺这几年来在世界各国可说是大行其道，原因除了纸材料价廉易得之外，纸本身的可塑性也相当高，是极佳的美术创作素材。
    </p>
    <p class="top_p" style="margin: 0">
      来参加纸艺社团，试想当一些普通的纸，在我们手中变成飞翔的蝴蝶、绽开的花朵、可爱的时装小人时，心情也变得难以想象的精致。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/xiuxian_5.jpg" alt="" />
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
        {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
        {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
        {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
        {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        },
      ],
      newData: 3,
      list2: [
        {
          img: require("../../assets/image/party/shuhua_1.png"),
        },
        {
          img: require("../../assets/image/party/shuhua_2.png"),
        },
        {
          img: require("../../assets/image/party/shuhua_3.png"),
        },
      ],
      dataContent: "",
      ContentStatus: false,
      remakTitle: "",
    };
  },
  methods: {
    getHtml(e) {
      this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
    },
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {},
};
</script>
<style scoped="scoped">
.title {
  font-weight: 800 !important;
}
p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet {
  display: inline-block;
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-decoration: underline;
  color: #3f674b;
  line-height: 54px;
  text-align: left;
  margin-top: 0.6rem;
  cursor: pointer;
}
.small_jiantou {
  display: inline-block;
  width: 0.1rem;
  height: 0.1875rem;
  background-image: url("../../assets/image/left_item1.png");
  background-size: 100% 100%;
}
.item_jiantou1 {
  margin-left: 0.125rem;
  margin-right: 0.05rem;
}
.item_jiantou2 {
  background-image: url("../../assets/image/left_item2.png");
  background-size: 100% 100%;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
</style>